import i18next from 'i18next';
import { keys } from './translator/translation_keys';
import { customColors } from './misc';

export const taskTypes = ({ assessmentName = '', observationName = '' }) => {
  return {
    INSPECTION: {
      value: 'INSPECTION',
      title: !!assessmentName
        ? assessmentName
        : i18next.t(keys.common.ASSESSMENT),
      icon: 'assignment_turned_in',
    },
    OBSERVATION: {
      value: 'OBSERVATION',
      title: !!observationName
        ? observationName
        : i18next.t(keys.common.OBSERVATION),
      icon: 'content_paste_search',
    },
    VEHICLE: {
      value: 'VEHICLE',
      title: 'Assets',
      icon: 'construction',
    },
  };
};

export const taskIntervals = {
  ONE_TIME: { value: 'ONE_TIME', label: 'One Time' },
  DAILY: { value: 'DAILY', label: 'Daily' },
  WEEKLY: { value: 'WEEKLY', label: 'Weekly' },
  MONTHLY: { value: 'MONTHLY', label: 'Monthly' },
  QUARTERLY: { value: 'QUARTERLY', label: 'Quarterly' },
  ANNUAL: { value: 'ANNUALLY', label: 'Annually' },
  CUSTOM: { value: 'CUSTOM', label: 'Custom' },
};

export const recurrencePatterns = {
  DATE: { value: 'DATE', label: 'Same date each period' },
  WEEKDAY: { value: 'WEEKDAY', label: 'Same weekday each period' },
};

export const taskStatus = {
  OVERDUE: { color: customColors.RED, title: 'Overdue' },
  IN_PROGRESS: {
    color: customColors.YELLOW,
    title: keys.common.IN_PROGRESS,
  },
  TODO: { color: customColors.BLUE, title: keys.common.TODO },
  COMPLETE: { color: customColors.GREEN, title: keys.common.COMPLETE },
};
